import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriverAssignmentTitle: {
        id: 'quoteandbind.ba.views.ba-driver-assignment-details.Vehicle Driver Assignment',
        defaultMessage: 'Vehicle Driver Assignment',
    },
});
